import format from 'date-fns/format'
import type { Time } from '../typings'

export const getOptionLabel = (x: Time | string) => {
  if (x === null || x.toString() === 'Invalid Date') return ''
  else if (typeof x === 'string') return x
  else return format(x, 'hh:mm aa')
}
